<template>
    <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
    <div v-else>
        <v-simple-table>
            <template v-slot:default>
                <thead>
                    <tr>
                        <th class="text-left">
                        </th>
                        <th class="text-left">
                            Species
                        </th>
                        <th class="text-left">
                            Barcode
                        </th>
                        <th class="text-left">
                            Collection Date
                        </th>
                        <th class="text-left">
                            Weight
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="item in availableSessions"
                        :key="item.DailyExtractionSessionID"
                        :class="item.SpeciesID == speciesID ? '' : 'text--disabled'">
                        <td>
                            <v-checkbox v-model="item.Selected"></v-checkbox>
                        </td>
                        <td>{{ item.SpeciesFullName }}</td>
                        <td>{{ item.Barcode }}</td>
                        <td>{{ item.SessionStartTime | formatDate }}</td>
                        <td>
                            <NumericEntry
                                v-model="item.Weight"
                                suffix="g"
                                :decimalPlaces="2"
                                :maxValue="10000"
                                :minValue="0">
                            </NumericEntry>
                        </td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td colspan="5" class="text-center">
                            <v-btn :disabled="!validateSessions"
                                color="success"
                                @click="addSelected">Add Selected</v-btn>
                        </td>
                    </tr>
                </tfoot>
            </template>
        </v-simple-table>
        <div v-if="saveError.length > 0">
            <v-alert text type="error">
                <v-row align="center">
                    <v-col class="grow">
                        <ul>
                            <li v-for="error in saveError" :key="error.DailyExtractionSessionID">
                                {{error.Barcode}} - {{error.message}}
                            </li>
                        </ul>
                    </v-col>
                    <v-col class="shrink">
                        <v-btn @click="loadSessions">Reload Sessions</v-btn>
                    </v-col>
                </v-row>
            </v-alert>
        </div>
    </div>
</template>

<script>
import * as venomPoolingAPI from "@/services/venomPoolingAPI";
import constants from 'comunet-btg-utah-repository-shared/constants';
import moment from 'moment';

import NumericEntry from "../common/NumericEntry";

export default {
    components: {
        NumericEntry
    },
    props: {
        speciesID: {
            type: Number,
            default: -1
        },
        monthlyPoolID: {
            type: Number,
            default: -1
        }
    },
    data() {
        return {
            loading: false,
            availableSessions: [],
            saveError: []
        }
    },
    computed: {
        validateSessions() {
            var selected =this.availableSessions.filter(x => x.Selected);
            return selected.length > 0 && selected.every(x => x.Weight && x.Weight > 0)
        }
    },
    methods: {
        async loadSessions() {
            this.loading = true;
            this.saveError = [];

            this.availableSessions = (await venomPoolingAPI.getMonthlyPoolAvailableSessions(this.speciesID)).sort((x, y) => {
                if (x.SpeciesID == this.speciesID) {
                    return y.DailyExtractionSessionID - x.DailyExtractionSessionID;
                }
                return x.SpeciesFullName < y.SpeciesFullName ? -1 : 1;
            }).map(z => {
                return {
                    Barcode: z.Barcode,
                    DailyExtractionSessionID: z.DailyExtractionSessionID,
                    Selected: false,
                    Weight: null,
                    SpeciesFullName: z.SpeciesFullName,
                    SpeciesID: z.SpeciesID,
                    SessionStartTime: z.SessionStartTime,
                    MonthlyPoolID: this.monthlyPoolID
                }
            });

            this.loading = false;
        },
        async addSelected() {
            this.saving = true;
            this.saveError = [];

            var result = await venomPoolingAPI.addDailyExtractionsToMonthlyPool(this.availableSessions.filter(x => x.Selected));

            if (result.every(x => x.success)) {
                this.loadSessions();
            } else {
                this.saveError = result.filter(x => !x.success);
            }

            this.$emit("sessionsAdded");

            this.saving = false;
        }
    },
    async created() {
        await this.loadSessions();
    },
    filters: {
        formatDate: function(value) {
            var date = moment(value);
            if (date.isValid){
                return date.format(constants.DATE_FORMAT);
            } else {
                return value;
            }
        }
    }
}
</script>